import React from "react";
import TableHead from "@mui/material/TableHead";
import PrimaryTableCell from "app/Components/Tables/PrimaryTableCell";
import StyledTableRow from "app/Components/Tables/StyledTableRow";

const MUICashTableHeader = () => (
  <TableHead>
    <StyledTableRow>
      <PrimaryTableCell align="center" key="gameName">
        Name
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Game">
        Game
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Limit">
        Limit
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Buyin">
        Buy-in
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Status">
        Status
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Distance">
        Distance
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Waitlist">
        Waitlist
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Options">
        Actions
      </PrimaryTableCell>
    </StyledTableRow>
  </TableHead>
);

export default MUICashTableHeader;
